import PropTypes from 'prop-types';
import { useNavigate } from 'react-router-dom';
// @mui
import { styled, useTheme } from '@mui/material/styles';
import { Box, Stack, AppBar, Toolbar, Chip , Alert,Button} from '@mui/material';
import { Offline, Online } from "react-detect-offline";
// hooks
import useAuth from '../../../hooks/useAuth';
import useOffSetTop from '../../../hooks/useOffSetTop';
import useResponsive from '../../../hooks/useResponsive';
// utils
import cssStyles from '../../../utils/cssStyles';
// config
import { HEADER, NAVBAR } from '../../../config';
// routes
import { PATH_DASHBOARD, PATH_AUTH } from '../../../routes/paths';
// components
 // import Logo from '../../../components/Logo';
import {LogoLight, LogoDark} from '../../../assets';
import Image from '../../../components/Image';
import Iconify from '../../../components/Iconify';
import { IconButtonAnimate } from '../../../components/animate';
//
import Searchbar from './Searchbar';
import AccountPopover from './AccountPopover';
import LanguagePopover from './LanguagePopover';
import ContactsPopover from './ContactsPopover';
import NotificationsPopover from './NotificationsPopover';

// ----------------------------------------------------------------------

const RootStyle = styled(AppBar, {
  shouldForwardProp: (prop) => prop !== 'isCollapse' && prop !== 'isOffset' && prop !== 'verticalLayout',
})(({ isCollapse, isOffset, verticalLayout, theme }) => ({
  ...cssStyles(theme).bgBlur(),
  boxShadow: 'none',
  height: HEADER.MOBILE_HEIGHT,
  zIndex: theme.zIndex.appBar + 1,
  transition: theme.transitions.create(['width', 'height'], {
    duration: theme.transitions.duration.shorter,
  }),
  [theme.breakpoints.up('lg')]: {
    height: HEADER.DASHBOARD_DESKTOP_HEIGHT,
    width: `calc(100% - ${NAVBAR.DASHBOARD_WIDTH + 1}px)`,
    ...(isCollapse && {
      width: `calc(100% - ${NAVBAR.DASHBOARD_COLLAPSE_WIDTH}px)`,
    }),
    ...(isOffset && {
      height: HEADER.DASHBOARD_DESKTOP_OFFSET_HEIGHT,
    }),
    ...(verticalLayout && {
      width: '100%',
      height: HEADER.DASHBOARD_DESKTOP_OFFSET_HEIGHT,
      backgroundColor: theme.palette.background.default,
    }),
  },
}));

// ----------------------------------------------------------------------

DashboardHeader.propTypes = {
  onOpenSidebar: PropTypes.func,
  isCollapse: PropTypes.bool,
  verticalLayout: PropTypes.bool,
};

export default function DashboardHeader({ onOpenSidebar, isCollapse = false, verticalLayout = false }) {
  const isOffset = useOffSetTop(HEADER.DASHBOARD_DESKTOP_HEIGHT) && !verticalLayout;
  const navigate = useNavigate();
  const isDesktop = useResponsive('up', 'lg');
  const theme = useTheme();
  const isLight = theme.palette.mode === 'light';
  const { user } = useAuth();
  console.log(user)
  const handleNavigate = () =>{
     navigate(PATH_DASHBOARD.user.account);
  }
  return (
    <RootStyle isCollapse={isCollapse} isOffset={isOffset} verticalLayout={verticalLayout}>
      <Toolbar
        sx={{
          minHeight: '100% !important',
          px: { lg: 5 },
        }}
      >
        {isDesktop && verticalLayout && <Image
              sx={{width:'16%',mt:0.2}}
              alt="logo"
              src={isLight?LogoDark:LogoLight}
              
            />}

        {!isDesktop && (
          <IconButtonAnimate onClick={onOpenSidebar} sx={{ mr: 1, color: 'text.primary' }}>
            <Iconify icon="eva:menu-2-fill" />
          </IconButtonAnimate>
        )}

        <Searchbar />
        <Box sx={{ flexGrow: 1 }} />

        <Stack direction="row" alignItems="center" spacing={{ xs: 0.5, sm: 1.5 }}>
        {
         
         isDesktop && user?.license_number===''  ?
          <Alert
  severity="info"
  color="info"
  action={
    <Button variant='outlined' onClick={handleNavigate} color="inherit" size="small">
      Update
    </Button>
  }
  sx={{ bgcolor: 'background.paper',mt:1 }}
>
 Please update your Credentials & License Number 
</Alert>:""
}
           <Online> <Chip color="success" icon={<Iconify icon="mdi:wifi-check" />} label="Connected" /> </Online>
          <Offline> <Chip color="error" icon={<Iconify icon="material-symbols:signal-wifi-bad" />} label="Disconnected" /> </Offline>
          <ContactsPopover />
          <AccountPopover />
        </Stack>
      </Toolbar>
    </RootStyle>
  );
}
